/* 🤖 this file was generated by svg-to-ts */
export const emperorIconShieldCheck: {
  name: 'shield_check';
  data: string;
} = {
  name: 'shield_check',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><g><path d="M0,0h24v24H0V0z" fill="none"/></g><g><path d="M12,2L4,5v6.09c0,5.05,3.41,9.76,8,10.91c4.59-1.15,8-5.86,8-10.91V5L12,2z M10.94,15.54L7.4,12l1.41-1.41l2.12,2.12 l4.24-4.24l1.41,1.41L10.94,15.54z"/></g></svg>`
};
